// extracted by mini-css-extract-plugin
export default {"root":"q_M6vEpK","content":"Fo3a5AOw","title":"rB1ZFNPt"};